function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m32.222 32.222h64.444v64.444h-64.444z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m0 193.333h32.222v225.556h64.444v-225.556h32.222v-64.444h-128.888z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m193.333 32.222h64.444v193.333h-64.444z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m161.111 322.222h32.222v96.667h64.444v-96.667h32.223v-64.444h-128.889z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m354.445 32.222h64.444v128.889h-64.444z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m451.111 193.333h-128.889v64.444h32.222v161.111h64.444v-161.11h32.222v-64.445z"
});

var SvgSettings = function SvgSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 451.111 451.111",
    viewBox: "0 0 451.111 451.111",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings.8351fccd.svg";
export { ForwardRef as ReactComponent };